import gql from 'graphql-tag';
export const getMetricsMarketingOfUserCompanies = gql`
query getMetricsMarketingTotalOfUserCompanies(
    $input: GetMetricsMarketingTotalOfUserCompaniesInput) {
        getMetricsMarketingTotalOfUserCompanies(
        getMetricsMarketingTotalOfUserCompaniesInput: $input) {
    companies {
      id
      name
      marketingTotals {
        totalLeads
        onTrackLeads
        contactedLeads
        totalVisits
        visitedLeads
        closedLeads
      }
    }
  }
}
`;
export const getMetricsMarketingOfUserCompaniesV2 = gql`
query getMetricsMarketingTotalOfUserCompaniesV2(
    $input: GetMetricsMarketingTotalOfUserCompaniesInput) {
        getMetricsMarketingTotalOfUserCompaniesV2(
        getMetricsMarketingTotalOfUserCompaniesInput: $input) {
    companies {
      id
      name
      companyGroup
      marketingTotals {
        totalLeads
        onTrackLeads
        unassignedLeads
        newLeads
        expiredLeads
        archivedLeads
        contactedLeads
        totalVisits
        visitedLeads
        closedLeads
      }
    }
  }
}
`;
export const getDataDashboard = gql`
query getDataDashboard(
    $input: GetDataDashboardInput) {
      getDataDashboard(
        getDataDashboardInput: $input) {
    companies {
      id
      name
      marketingTotals {
        totalLeads
        onTrackLeads
        contactedLeads
        totalVisits
        visitedLeads
        closedLeads
      }
    }
  }
}
`;

export const getMetricsBdc = gql`
query getMetricsBdc($input: GetMetricsBdcInput){
  getMetricsBdc(getMetricsBdcInput: $input){
    companies {
      id
      name
      totalLeads
      unnasignedLeads
      asignedLeads
      noTrackLeads
      expiredOnTrackLeads
      noExpiredOnTrackLeads
    }
  }
}
`;
